import axios from 'axios'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { TypeVas, TypeVasUpdate } from '../../../interfaces/TypeVas/TypeVas'
import { ApiConfig } from '../../../config/api'

export const getTypeVas = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<TypeVas>
) => {
  const url = new URL(`${ApiConfig.TypeVasApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const deleteTypeVas = (id: number) => {
  const url = new URL(`${ApiConfig.TypeVasApi}/${id}`)

  return axios.delete(url.toString())
}

export const updateTypeVas = (id: number, dto: TypeVasUpdate) => {
  const url = new URL(`${ApiConfig.TypeVasApi}/${id}`)
  return axios.put(url.toString(), dto)
}

export const createTypeVas = (dto: TypeVasUpdate) => {
  const url = new URL(`${ApiConfig.TypeVasApi}`)
  return axios.post(url.toString(), dto)
}
